import React from 'react'
import OrderTable from './OrderTable'
import { useIntl } from 'react-intl'
import messages from '../../../messages'
import TermsAndConditions from '@src/routes/Configurators/components/TermsAndConditions/TermsAndConditions'
import { configContext } from '../DnaPlates'

const OrderConfirmation = (props) => {
  const intl = useIntl()
  const { productDetails, configuratorAddToMiniCart } = props
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const { dispatch } = React.useContext(configContext)

  const setTermsOpen = (value) => {
    setDialogOpen(value)
  }
  const updateError = (value) => {
    if (value === true || value === false) {
      if (value) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: value,
      })
    }
  }

  React.useEffect(() => {
    window.scrollTo(0, 0)
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
  }, [])

  return (
    <>
      <div>
        <OrderTable
          productDetails={productDetails}
          updateError={updateError}
          configuratorAddToMiniCart={configuratorAddToMiniCart}
          setTermsOpen={setTermsOpen}
        />
        <TermsAndConditions
          dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
        />
      </div>
    </>
  )
}

export default OrderConfirmation
